
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24z","fill":"#E2E2E2"}}),_c('path',{attrs:{"d":"M34.125 18.765l-1.166.301c-1.08-3.447-2.72-5.429-5.829-5.429h-3.972c-.173 2.24-.26 5.903-.216 9.738l2.677-.086c1.77-.043 2.504-1.379 2.936-3.318h.993v8.144h-.993c-.432-1.982-1.166-3.275-2.98-3.361l-2.676-.086c.043 2.93.13 5.386.216 6.85.172 2.155.777 3.103 2.331 3.362l1.339.129V36h-12.91v-.991l1.08-.13c1.51-.215 2.158-1.163 2.33-3.36.303-3.576.346-10.988 0-15.124-.172-2.154-.776-3.102-2.33-3.318l-1.08-.13V12h20.163l.087 6.765z","fill":"#787878"}})])
          )
        }
      }
    